module.exports = "/_next/static/images/img-hero-explorer-4b1595ae532f409a0dcb323dc3a09886.svg";